export default __webpack_public_path__ + "static/media/scale_img.e4c69221.mov";